//#region app
import { isCpf } from './is-cpf';
import { isCnpj } from './is-cnpj';
//#endregion

export function isCpfCnpj(cpfCnpj: string): boolean {
  return isCpf(cpfCnpj) || isCnpj(cpfCnpj);
}
